import React from 'react'
import { func, object, string } from 'prop-types'
import styled from 'styled-components'
import Textbox from '@taglivros/oef_componentes/build/components/textbox'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'

import { handleKeyPressCaracteresEspeciais, isEmptyObject } from '../../utils/helpers/helpers'
import LogoTAG from '../LogoTAG/LogoTAG'

const Destaque = styled.h3`
  color: ${StyleGuide.cores.azul};
  font-size: 20px;
  ${StyleGuide.boldFonte}
  margin: 10px 0;

  @media (min-width: ${StyleGuide.mediaQuery.tablet}) {
    font-size: 40px;
  }
`

const InputWrapper = styled.div`
  max-width: 250px;
`

const ListaInfoResgate = styled.ul`
  display: flex;
  margin-top: 75px;

  strong {
    color: ${StyleGuide.cores.cinza300};
    display: block;
    ${StyleGuide.boldFonte}
    font-size: 14px;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  li {
    color: ${StyleGuide.cores.cinza500};
    ${StyleGuide.defaultFonte}
    font-size: 18px;
    width: calc(100%/2);

    span {
      font-size: 27px;
    }
  }
`

const Subtitulo = styled.p`
  ${StyleGuide.tipografia.textoHelper}
  color: ${StyleGuide.cores.cinza300};
  margin: 10px 0;
  text-transform: uppercase;
`

const TextoInfoResgate = styled.div`
  p {
    ${StyleGuide.tipografia.textoDefault}
    color: ${props => props.codigoValido ? `${StyleGuide.cores.cinza500}` : `${StyleGuide.cores.cinza300}`};
    margin-bottom: 20px;
  }
`

const Titulo = styled.h2`
  align-items: center;
  color: ${StyleGuide.cores.cinza500};
  display: flex;
  font-size: 18px;
  ${StyleGuide.boldFonte}
  margin: unset;
  margin-bottom: 10px;
`

const CodigoResgate = ( {
  codigoResgate,
  dadosAssinaturaPresente,
  erroCodigo,
  onChangeCodigo,
  onClick,
  periodo,
} ) => {
  const temDadosPresente = !isEmptyObject( dadosAssinaturaPresente )
  const textoPeriodo = `${periodo} ${periodo === 1 ? 'mês' : 'meses'}`

  return (
    <Card largura="540px">
      <Titulo>
        Confira no seu e-mail o código enviado e digite-o abaixo
      </Titulo>

      <InputWrapper>
        <Textbox
          buttonValue="Confirmar"
          erro={ erroCodigo }
          label="Código"
          name="codigo"
          onChange={ onChangeCodigo }
          onClick={ onClick }
          onKeyPress={ handleKeyPressCaracteresEspeciais }
          sucesso={ temDadosPresente }
          tipo="text"
          value={ codigoResgate }
        />
      </InputWrapper>

      <Subtitulo>
        Seu presente
      </Subtitulo>

      { temDadosPresente ?
        <TextoInfoResgate codigoValido={ temDadosPresente }>
          <Destaque>
            Parabéns!
          </Destaque>

          <p>
            {`Você ganhou `}<strong>{ textoPeriodo }</strong> {`de assinatura, ou seja,
            ${periodo} caixinha${parseInt( periodo, 10 ) === 1 ? '' : 's'} na porta da sua casa!`}
          </p>

          <p>
            { `Você poderá conferir a chegada das suas caixinhas pela `}<strong>área do associado</strong>

            { `, além de acesso ao `}<strong>aplicativo da TAG</strong>{ ` no seu celular e desconto na loja!` }
          </p>
        </TextoInfoResgate>
        : '-' }

      <ListaInfoResgate>
        <li>
          <strong>Modalidade</strong>

          { temDadosPresente ?
            <LogoTAG
              modalidade={ dadosAssinaturaPresente.presente.categoria }
              propriedadeParaComparacao="visualizacao"
            />
            : '-' }
        </li>

        <li>
          <strong>Período</strong>

          { temDadosPresente ?
            textoPeriodo
            : '-' }
        </li>
      </ListaInfoResgate>
    </Card>
  )
}

CodigoResgate.propTypes = {
  'codigoResgate': string.isRequired,
  'dadosAssinaturaPresente': object.isRequired,
  'erroCodigo': string,
  'onChangeCodigo': func,
  'onClick': func,
  'periodo': string.isRequired,
}

CodigoResgate.defaultProps = {
  'erroCodigo': '',
  'onChangeCodigo': () => {},
  'onClick': () => {},
}

export default CodigoResgate
